import moment from 'moment-timezone';
import { TimelinePeriodSwitch, TimelineView } from './timeline';

export class TimelinePeriod {
  constructor(private start: moment.Moment, private end: moment.Moment) {}

  getMidpoint(): number {
    return (this.start.valueOf() + this.end.valueOf()) / 2;
  }

  getStart(): moment.Moment {
    return this.start;
  }

  getEnd(): moment.Moment {
    return this.end;
  }

  getStartMs(): number {
    return this.start.valueOf();
  }

  getEndMs(): number {
    return this.end.valueOf();
  }

  clone() {
    return new TimelinePeriod(this.start.clone(), this.end.clone());
  }

  toString() {
    return `${this.start.format('YYYY-MM-DD HH:mm')} - ${this.end.format('YYYY-MM-DD HH:mm')}`;
  }

  switchPeriod(view: TimelineView, periodSwitch: TimelinePeriodSwitch): TimelinePeriod {
    let newStart = this.start.clone();
    let newEnd = this.end.clone();
    const direction = periodSwitch === TimelinePeriodSwitch.Next ? 1 : -1;

    switch (view) {
      case TimelineView.Day:
        newStart.add(direction, 'day');
        newEnd = newStart.clone().add(1, 'day');
        break;

      case TimelineView.Week:
        newStart.add(direction, 'week');
        newEnd = newStart.clone().add(1, 'week');
        break;

      case TimelineView.TwoWeeks:
        newStart.add(direction * 2, 'week');
        newEnd = newStart.clone().add(2, 'week');
        break;

      case TimelineView.ThreeWeeks:
        newStart.add(direction * 3, 'week');
        newEnd = newStart.clone().add(3, 'week');
        break;

      case TimelineView.Month:
        newStart.add(direction, 'month');
        newEnd = newStart.clone().add(1, 'month');
        break;

      case TimelineView.ThreeMonths:
        newStart.add(direction * 3, 'months');
        newEnd = newStart.clone().add(3, 'months');
        break;

      case TimelineView.Year:
        newStart.add(direction, 'year');
        newEnd = newStart.clone().add(1, 'year');
        break;

      default:
        break;
    }

    return new TimelinePeriod(newStart, newEnd);
  }
}
